'use client';

import { useState } from 'react';
import Image from 'next/image';

interface Props {
  src?: string | null;
  name: string;
  size?: number;
  displayName?: string;
}

export default function UserAvatar({ src, name, size = 40, displayName }: Props) {
  const [errored, setErrored] = useState(false);
  const initial = (name.charAt(0) || '?').toUpperCase();

  return (
    <div
      className='rounded-circle overflow-hidden bg-light flex-shrink-0 d-flex align-items-center justify-content-center'
      style={{ width: size, height: size }}
    >
      {src && !errored ? (
        <Image
          src={src}
          alt={name}
          width={size}
          height={size}
          style={{ objectFit: 'cover', width: size, height: size }}
          onError={() => setErrored(true)}
        />
      ) : (
        <span
          className='text-muted font-weight-bold'
          style={{ fontSize: size * 0.4 }}
        >
          {initial}
        </span>
      )}
    </div>
  );
}
